<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary">
          <v-card-title>
            <div class="text-subtitle-1 font-weight-bold">Información general</div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Evaluado"
                    :value="getFullName(respetoPrincipiosValores.detalle.evaluado)"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Evaluador"
                    :value="getFullName(respetoPrincipiosValores.detalle.evaluador)"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Municipio"
                    :value="respetoPrincipiosValores.detalle.municipio.nombre"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Fecha inicial"
                    :value="respetoPrincipiosValores.detalle.fechaInicial"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Fecha fin"
                    :value="respetoPrincipiosValores.detalle.fechaFin"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Fecha de aplicación"
                    :value="respetoPrincipiosValores.detalle.fechaAplicacion"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Institución de seguridad pública a la que aspira"
                    v-model="respetoPrincipiosValores.detalle.institucionSeguridadAspirada"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Aspirante al puesto de"
                    v-model="respetoPrincipiosValores.detalle.puestoAspirado"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card color="primary" class="card">
          <v-card-title>
            <div class="text-subtitle-1 font-weight-bold">Reactivos</div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" v-for="(reactivo, index) in reactivos" :key="index">
                  <v-row align="center">
                    <v-col cols="1">
                      {{ index + 1 }}
                    </v-col>
                    <v-col cols="8">
                      <div class="text-subtitle-2">
                        {{ reactivo.CatReactivo.title }}
                      </div>
                    </v-col>
                    <v-col>
                      <v-select
                        label="Frecuencia de medición"
                        :value="respetoPrincipiosValores.reactivos[index].idFrecuencia"
                        @input="setFrecuencia(reactivo.id, $event)"
                        rounded
                        filled
                        dense
                        :items="frecuencia"
                        item-value="id"
                        item-text="title"
                        item-color="secondary"
                        color="secondary"
                        background-color="primary"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-divider class="my-2"></v-divider>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="8">
        <v-card color="primary" class="card">
          <v-card-title>
            <div class="text-subtitle-1 font-weight-bold">Observaciones</div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    label="Ingrese observaciones"
                    v-model="respetoPrincipiosValores.detalle.observaciones"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    no-resize
                    rows="3"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card color="primary" class="card">
          <v-card-title>
            <div class="text-subtitle-1 font-weight-bold">Resultados</div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="d-flex">
                  <span>Resultado:</span>
                  <v-spacer></v-spacer>
                  <span>
                    {{ RESULTADOS[getResultado] }}
                  </span>
                </v-col>
                <v-col cols="12" class="d-flex"
                  ><span>Puntaje total:</span>
                  <v-spacer />
                  <span>{{ getPuntajeTotal }}</span>
                </v-col>
                <v-col cols="12" class="d-flex"
                  ><span>Calificación:</span>
                  <v-spacer></v-spacer>
                  <span>{{ getCalificacion }}</span>
                </v-col>
                <v-col cols="12">
                  <BaseSelect
                    v-model="respetoPrincipiosValores.detalle.status"
                    label="Estatus"
                    :items="estatusEvaluacionItems"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-btn color="secondary" @click="triggerSaveEvaluacionRespetoPrincipios()" :loading="loading"
          >Guardar evaluación</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// * DEPRECATED COMPONENT
// Use EditaEvaluacionDesempeñoAcademicoDialogContent.vue instead
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {
  getCalification,
  getIdResultado,
  getPuntajeTotal,
  RESULTADOS,
} from '../../modules/evaluacion-desempeño-academico/domain/rules/evaluation.rules'
import UpdateRespetoValoresPrincipios from '@modules/respeto-valores-principios/application/UpdateRespetoValoresPrincipios.usecase'
import BaseSelect from '../base/BaseSelect.vue'
import RespetoValoresPrincipiosApiRepository from '@modules/respeto-valores-principios/infrastructure/RespetoValoresPrincipiosApi.repository'

export default {
  components: { BaseSelect },

  data() {
    return {
      loading: false,
      RESULTADOS,
    }
  },

  async mounted() {
    await this.fetchEstatusEvaluacion()
  },

  computed: {
    ...mapGetters('frecuenciaRespetoPrincipio', {
      frecuencia: 'getFrecuenciaRespetoPrincipio',
    }),

    ...mapGetters('reactivoValor', {
      reactivos: 'getReactivoValor',
    }),

    ...mapGetters('estatusEvaluacion', {
      estatusEvaluacionItems: 'getEstatusEvaluacion',
    }),

    ...mapGetters('respetoPrincipiosValores', {
      respetoPrincipiosValores: 'getSelectedEvaluation',
    }),

    getResultado: function () {
      return getIdResultado(this.getPuntajeTotal)
    },

    getPuntajeTotal: function () {
      return getPuntajeTotal(this.respetoPrincipiosValores.reactivos)
    },

    getCalificacion: function () {
      return getCalification(this.getPuntajeTotal)
    },
  },

  methods: {
    ...mapActions('respetoPrincipiosValores', ['updateRespetoPrincipiosValores', 'updateEstatus']),
    ...mapActions('estatusEvaluacion', ['fetchEstatusEvaluacion']),
    ...mapMutations('dialog', ['CLOSE_DIALOG']),

    triggerSaveEvaluacionRespetoPrincipios: async function () {
      this.loading = true

      this.respetoPrincipiosValores.puntajeTotal = this.getPuntajeTotal
      this.respetoPrincipiosValores.calificacion = this.getCalificacion
      this.respetoPrincipiosValores.idResultado = this.getResultado

      await new UpdateRespetoValoresPrincipios(new RespetoValoresPrincipiosApiRepository()).execute(
        this.respetoPrincipiosValores
      )

      this.CLOSE_DIALOG()
    },

    setFrecuencia: function (idReactivo, idFrecuencia) {
      const index = this.respetoPrincipiosValores.reactivos.findIndex((reactivo) => reactivo.idReactivo == idReactivo)
      this.respetoPrincipiosValores.reactivos[index].idFrecuencia = idFrecuencia
    },
  },
}
</script>
